import React, { Component } from 'react';
import Button from '@react/react-spectrum/Button';
import ModalTrigger from '@react/react-spectrum/ModalTrigger';
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import CustomAgreementRejectDialog from './CustomAgreementRejectDialog';
import agreementService from '../../services/AgreementService';
import * as _ from 'lodash';
import { analysticsConstant } from '../../constants/analysticsConstant';
import { trackVIPMPDirectEvent } from '../../services/analytics-util';

export class AgreementRejectModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            error: null
        };
        this.confirm = this.confirm.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleClose() {
        // Reset state when modal closes
        this.setState({
            isLoading: false,
            error: null
        });
    }

    async confirm(rejectionReason) {
        const { agreementId, onSuccess, onError, onStart } = this.props;
        
        if (!agreementId) {
            return;
        }

        if (!rejectionReason) {
            return;
        }

        // Call start callback to show global loader
        if (onStart) {
            onStart(agreementId);
        }

        this.setState({ isLoading: true, error: null });
        
        try {
            
            const response = await agreementService.rejectRequest(agreementId, rejectionReason);
            
            if (response && (response.status === 200 || response.status === 201)) {
                
                // Close the modal on success
                this.handleClose();
                
                // Call success callback to refresh agreement details and show toast
                if (onSuccess) {
                    onSuccess(agreementId, rejectionReason);
                }
                const metadata = _.has(response, 'data') ? response.data : '';
                const analysticsObj = {
                    pageName: 'VIPMP '+analysticsConstant.CUSTOMER_APPORVAL_PORTAL,
                    agentLdap: _.has(metadata, 'createdBy') ? metadata.createdBy : '',
                    customerGuid: _.has(metadata, 'customerGUID') ? metadata.customerGUID : '',
                    customerCountryCode: _.has(metadata, 'details.accountInfo.address.country.code') ? metadata.details.accountInfo.address.country.code : '',
                    workFlowId: 'Agreement Approval flow',
                    agreementId: _.has(metadata, 'id') ? metadata.id : '',
                    events: 'event227',
                    flowType: 'Approval Portal Agreement Decline',
                    accountId: _.has(metadata, 'details.accountInfo.accountId') ? metadata.details.accountInfo.accountId : '',
                    orgID: _.has(metadata, 'details.orgId') ? metadata.details.orgId : '',
                    agreementStatus: 'DECLINED',
                    contractId: _.has(metadata, 'details.accountInfo.contractId') ? metadata.details.accountInfo.contractId : '',
                    agreementType: _.has(metadata, 'details.agreementType') ? metadata.details.agreementType : '',
                    agreementSubType: _.has(metadata, 'details.subType') ? metadata.details.subType : '',
                    autoRenewal: _.has(metadata, 'details.orderDetails.autoRenewal') ? metadata.details.orderDetails.autoRenewal : '',
                    currencyCode: _.has(metadata, 'details.currency') ? metadata.details.currency : '',
                    totalValue: _.has(metadata, 'details.orderDetails.totals.totalPrice') ? metadata.details.orderDetails.totals.totalPrice : ''
                };
                trackVIPMPDirectEvent(analysticsObj);
            } else {
                throw new Error(`Unexpected response status: ${response && response.status ? response.status : 'unknown'}`);
            }
            
        } catch (error) {
            
            const errorMessage = this.getErrorMessage(error);
            this.setState({ error: errorMessage });
            
            // Call error callback
            if (onError) {
                onError(error, agreementId, rejectionReason);
            }
            
        } finally {
            this.setState({ isLoading: false });
        }
    }

    getErrorMessage(error) {
        if (error.response && error.response.data && error.response.data.message) {
            return error.response.data.message;
        } else if (error.response && error.response.status === 404) {
            return 'Agreement not found';
        } else if (error.response && error.response.status === 403) {
            return 'You do not have permission to reject this agreement';
        } else if (error.response && error.response.status >= 500) {
            return 'Server error occurred. Please try again later';
        } else if (error.message) {
            return error.message;
        } else {
            return 'Failed to reject agreement. Please try again';
        }
    }

    render() {
        const { isLoading } = this.state;
        
        return (
            <ModalTrigger>
                <Button 
                    label={this.props.btnLabel || "Reject Agreement"} 
                    variant={this.props.variant || "negative"} 
                    modalTrigger  
                    data-am-id="agreementRejectModalBtn" 
                    data-agreement-id={this.props.agreementId}
                    disabled={isLoading || this.props.disabled}
                />
                <CustomAgreementRejectDialog 
                    confirm={this.confirm}
                    onCancel={this.handleClose}
                    agreementId={this.props.agreementId}
                    customerName={this.props.customerName}
                    totalValue={this.props.totalValue}
                    currency={this.props.currency}
                    backdropClickable={false}
                    getSalesText={this.props.getSalesText}
                    isLoading={isLoading}
                    error={this.state.error}
                />
            </ModalTrigger>
        );
    }
}

const mapStateToProps = (state)=>{
    return{
        rejectReasons:state.AppReducer.rejectedAgreementReasons
    }
};

const mapDispatchToProps = (dispatch)=>{
    return{
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(AgreementRejectModal));
